import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _keysInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/keys';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { getTestId } from '../../utils/testId.js';
import { noop } from '../../utils/noop.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import * as React from 'react';
import Text from '../Text/Text.js';
import Icon from '../Icon/Icon.js';

var _excluded$2 = ["title", "titleId"];
var StarFilled12 = function StarFilled12(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M6.021.25c-.25 0-.51.15-.61.44L4.238 4.107H.644c-.63 0-.881.819-.37 1.179l2.853 2.048-1.211 3.547c-.16.46.2.869.61.869.12 0 .251-.04.371-.12l3.104-2.228 3.104 2.228c.12.09.25.12.371.12.41 0 .771-.41.61-.87l-1.21-3.546 2.853-2.048c.51-.37.25-1.18-.37-1.18H7.773L6.612.69a.635.635 0 0 0-.61-.44z"
  }));
};
StarFilled12.Size = 12;
StarFilled12.Title = "StarFilled";

var _excluded$1 = ["title", "titleId"];
var StarFilled16 = function StarFilled16(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M8.893 1.354C8.625.48 7.4.452 7.09 1.31L5.656 5.3H1.608c-.917 0-1.302 1.17-.564 1.714L4.143 9.3l-1.21 4.487c-.238.885.79 1.561 1.508.992l3.554-2.818 3.474 2.812c.71.575 1.743-.086 1.519-.971L11.85 9.305l3.105-2.29c.738-.545.353-1.715-.564-1.715h-4.287z"
  }));
};
StarFilled16.Size = 16;
StarFilled16.Title = "StarFilled";

var _excluded = ["title", "titleId"];
var StarFilled24 = function StarFilled24(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M10.768 2.425c.355-1.12 1.847-1.193 2.352-.22q.075.101.113.228L14.99 8.15h5.735c1.244 0 1.727 1.575.771 2.308l-4.697 3.6 1.787 5.805c.35 1.184-.998 2.16-2 1.388h-.001L12 17.732 7.415 21.25l-.002.001c-1.009.777-2.35-.224-1.997-1.392v-.003l1.786-5.797-4.698-3.6c-.972-.746-.443-2.31.772-2.31H9.01z"
  }));
};
StarFilled24.Size = 24;
StarFilled24.Title = "StarFilled";

var styles = {
  "unit-base": "4",
  "rating": "web_ui__Rating__rating",
  "star": "web_ui__Rating__star",
  "label": "web_ui__Rating__label",
  "star-content": "web_ui__Rating__star-content",
  "small": "web_ui__Rating__small",
  "focus-ring": "web_ui__Rating__focus-ring",
  "regular": "web_ui__Rating__regular",
  "large": "web_ui__Rating__large",
  "star-first-half": "web_ui__Rating__star-first-half",
  "full": "web_ui__Rating__full",
  "star-second-half": "web_ui__Rating__star-second-half",
  "empty": "web_ui__Rating__empty",
  "half-full": "web_ui__Rating__half-full",
  "interactive": "web_ui__Rating__interactive",
  "star-focus-ring": "web_ui__Rating__star-focus-ring",
  "focus-container": "web_ui__Rating__focus-container",
  "no-stars": "web_ui__Rating__no-stars"
};

var Size = /*#__PURE__*/function (Size) {
  Size["Small"] = "small";
  Size["Regular"] = "regular";
  Size["Large"] = "large";
  return Size;
}(Size || {});
var MAX_RATING = 5;
var FULL_STAR_THRESHOLD = 0.75;
var HALF_STAR_THRESHOLD = 0.25;
var iconSizeMap = _defineProperty(_defineProperty(_defineProperty({}, Size.Small, StarFilled12), Size.Regular, StarFilled16), Size.Large, StarFilled24);
var cssClasses = classNames.bind(styles);
var Rating = function Rating(_ref) {
  var text = _ref.text,
    emptyStateText = _ref.emptyStateText,
    _ref$value = _ref.value,
    ratingValue = _ref$value === void 0 ? 0 : _ref$value,
    _ref$size = _ref.size,
    ratingSize = _ref$size === void 0 ? Size.Regular : _ref$size,
    name = _ref.name,
    _ref$isInteractive = _ref.isInteractive,
    interactive = _ref$isInteractive === void 0 ? false : _ref$isInteractive,
    aria = _ref.aria,
    testId = _ref.testId,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect;
  var parseStars = function parseStars() {
    var halfStars = 0;
    var fullStars = 0;
    var remainderValue = ratingValue % 1;
    if (remainderValue >= FULL_STAR_THRESHOLD) {
      fullStars += 1;
    } else if (remainderValue >= HALF_STAR_THRESHOLD) {
      halfStars = 1;
    }
    fullStars += Math.floor(ratingValue);
    var emptyStars = MAX_RATING - fullStars - halfStars;
    return {
      halfStars: halfStars,
      fullStars: fullStars,
      emptyStars: emptyStars
    };
  };
  var handleChange = function handleChange(event) {
    event.stopPropagation();
    onSelect(+event.target.value, event);
  };
  var renderStar = function renderStar(icon, target, isInteractive) {
    var _context, _context2;
    var interactiveTestIdPrefix = isInteractive ? 'interactive-' : '';
    return /*#__PURE__*/jsxs("div", {
      className: styles['star-content'],
      "aria-hidden": true,
      children: [/*#__PURE__*/jsx("span", {
        className: styles['star-first-half'],
        children: /*#__PURE__*/jsx(Icon, {
          name: icon,
          role: "img",
          testId: getTestId(testId, _concatInstanceProperty(_context = "".concat(interactiveTestIdPrefix, "star-")).call(_context, target, "-icon-first-half"))
        })
      }), /*#__PURE__*/jsx("span", {
        className: styles['star-second-half'],
        children: /*#__PURE__*/jsx(Icon, {
          name: icon,
          role: "img",
          testId: getTestId(testId, _concatInstanceProperty(_context2 = "".concat(interactiveTestIdPrefix, "star-")).call(_context2, target, "-icon-second-half"))
        })
      }), /*#__PURE__*/jsx("div", {
        className: styles['star-focus-ring']
      })]
    });
  };
  var renderInteractiveStars = function renderInteractiveStars(count, selected, size) {
    var _context3, _context4;
    return /*#__PURE__*/jsxs("span", {
      role: "radiogroup",
      className: styles['focus-container'],
      children: [_mapInstanceProperty(_context3 = _Array$from(_keysInstanceProperty(_context4 = Array(count + 1)).call(_context4))).call(_context3, function (target) {
        var _context5;
        var modifier = selected >= target ? 'full' : 'empty';
        var inputName = name || 'rating';
        var inputId = _concatInstanceProperty(_context5 = "".concat(inputName, "-")).call(_context5, target);
        var isRated = target > 0;
        var starTitle = target.toString();
        var inputClasses = cssClasses(_defineProperty({}, styles['no-stars'], !isRated));
        var input = /*#__PURE__*/jsx("input", {
          className: inputClasses,
          onChange: handleChange,
          type: "radio",
          name: inputName,
          id: inputId,
          value: target,
          checked: selected === target,
          "data-testid": getTestId(testId, "interactive-star-".concat(target, "-input")),
          "aria-label": starTitle
        }, target);
        return isRated ? /*#__PURE__*/jsxs("label", {
          className: cssClasses(styles.star, modifier),
          htmlFor: inputId,
          "data-testid": getTestId(testId, "interactive-star-".concat(target)),
          children: [input, renderStar(iconSizeMap[size], target, true)]
        }, target) : input;
      }), /*#__PURE__*/jsx("span", {
        className: styles['focus-ring']
      })]
    });
  };
  var renderStars = function renderStars(count, modifier, size) {
    var _context6, _context7;
    return _mapInstanceProperty(_context6 = _Array$from(_keysInstanceProperty(_context7 = Array(count)).call(_context7))).call(_context6, function (value) {
      var target = value + 1;
      return /*#__PURE__*/jsx("div", {
        className: cssClasses(styles.star, modifier),
        "data-testid": getTestId(testId, "star-".concat(target)),
        children: renderStar(iconSizeMap[size], target)
      }, value);
    });
  };
  var renderStarItems = function renderStarItems(stars, size) {
    return [renderStars(stars.fullStars, 'full', size), renderStars(stars.halfStars, 'half-full', size), renderStars(stars.emptyStars, 'empty', size)];
  };
  var ratingClasses = cssClasses(styles.rating, ratingSize, _defineProperty({}, styles.interactive, interactive));
  var stars = parseStars();
  var textType = ratingSize === Size.Small ? Text.Type.Caption : Text.Type.Body;
  if (!ratingValue && emptyStateText) {
    return /*#__PURE__*/jsx("div", {
      className: ratingClasses,
      "data-testid": testId,
      children: /*#__PURE__*/jsx("div", {
        className: cssClasses(styles.label),
        children: /*#__PURE__*/jsx(Text, {
          as: "span",
          text: emptyStateText,
          type: textType,
          testId: getTestId(testId, 'empty-state-text')
        })
      })
    });
  }
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({
    className: ratingClasses
  }, aria), {}, {
    "data-testid": testId,
    role: "group",
    children: [interactive ? renderInteractiveStars(MAX_RATING, stars.fullStars, ratingSize) : renderStarItems(stars, ratingSize), text !== undefined && /*#__PURE__*/jsx("div", {
      className: cssClasses(styles.label),
      children: /*#__PURE__*/jsx(Text, {
        as: "span",
        text: text,
        type: textType,
        testId: getTestId(testId, 'text')
      })
    })]
  }));
};
Rating.Size = Size;

export { Rating as default };
//# sourceMappingURL=Rating.js.map
